export const CONSTANT = {
  HEADING_TEXT: "Welcome to your Gratitude Journal",
  HEADING_TEXT_NO_USER: "Welcome to the Gratitude Journal",
  SUBHEADING_TEXT: "Record your entry for today",
};
